module.exports = __webpack_public_path__ + "static/media/wiz_motorboat_selected_ic.f81459df.svg";